module.exports = __webpack_public_path__ + "img/transfer.e5ac64f2.svg";